import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { remoteConfig } from '../config/firebase';
import { SupportedLanguage, TranslationDictionary } from './types';

/**
 * Detectar idioma del navegador
 */
export const detectLanguage = (): SupportedLanguage => {
  const browserLang = navigator.language?.split('-')[0] || 'es';
  if (browserLang === 'en') return 'en';
  if (browserLang === 'pt') return 'pt';
  return 'es';
};

/**
 * Obtener traducciones desde Remote Config
 */
export const fetchTranslations = async (language: SupportedLanguage): Promise<TranslationDictionary> => {
  try {
    // Intentar obtener los valores más recientes
    await fetchAndActivate(remoteConfig).catch(err => {
      console.warn('Remote Config fetchAndActivate failed, using defaults/cache:', err);
    });

    const key = `translations_${language}`;
    const raw = getValue(remoteConfig, key).asString();
    
    if (raw) {
      try {
        return JSON.parse(raw) as TranslationDictionary;
      } catch (parseError) {
        console.error(`Error parsing translations for ${language}:`, parseError);
      }
    } else {
      console.warn(`No translation found for key: ${key}`);
    }
  } catch (error) {
    console.error('General error in fetchTranslations:', error);
  }

  // Fallback: intentar español (nuestro idioma base)
  try {
    const rawEs = getValue(remoteConfig, 'translations_es').asString();
    if (rawEs) {
      return JSON.parse(rawEs) as TranslationDictionary;
    }
  } catch (fallbackError) {
    console.error('Fallback to Spanish also failed:', fallbackError);
  }

  return {};
};
